import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=6add17cc"
import script from "./OrganizationCard.vue?vue&type=script&lang=ts"
export * from "./OrganizationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports